import * as React from "react";
import { cn } from "../../lib/utils";

/* Layout wrapper: horizontal padding comes from AppLayout (fluid width). Use for flex/stack only. */
const PageContainer = React.forwardRef(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("flex flex-col min-h-0", className)}
        {...props}
      >
        {children}
      </div>
    );
  },
);
PageContainer.displayName = "PageContainer";

export { PageContainer };
